import { createContext, useContext } from 'react'

const EmpresaGestionContext = createContext(null)

export const useEmpresaGestion = () => {
  const context = useContext(EmpresaGestionContext)
  return context || { empresaId: null, empresa: null, esGestion: false, tipoGestor: null, esAsesoria: false }
}

export const EmpresaGestionProvider = ({ children, empresaId, empresa, tipoGestor = 'super_admin' }) => {
  const value = {
    empresaId,
    empresa,
    esGestion: true,
    tipoGestor,                        // 'super_admin' | 'asesoria'
    esAsesoria: tipoGestor === 'asesoria',
    nivelAcceso: tipoGestor === 'asesoria' ? (empresa?.nivel_acceso || 'admin') : 'admin'
  }

  return (
    <EmpresaGestionContext.Provider value={value}>
      {children}
    </EmpresaGestionContext.Provider>
  )
}

export default EmpresaGestionContext
